import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./VideoListingContentComponent.scss";
import { Tab, Tabs } from "react-bootstrap";
import ListingFilterSectionComponent from "../ListingFilterSection/ListingFilterSectionComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  getMyVideos,
  getMyVideosClear,
  getUpcomingVideosReq,
  getVideoListCatData,
  getVideoListCatDataClear,
} from "../../../../redux/video/actions";
import {
  FreeForYou,
  FreePaidSubscription,
  PriceAt,
  ProductCardPriceInfo,
  PurchasedOn,
  SessionKeys,
  convertTimeFormat,
  getPriceInfoForEntity,
  getProcureInfo,
  redirectToPageUtil,
} from "../../../../utils/AppUtils";
import _ from "lodash";
import {
  getAssignBrokerCourse,
  getAssignBrokerCourseClear,
  getVideoProductCategories,
} from "../../../../redux/courses/actions";
import ProductCardComponent from "../../ProductCard/ProductCardComponent";
import CONFIG from "../../../../utils/config";
import { useNavigate } from "react-router-dom";
import ListingBodyComponent from "../ListingBodyComponent/ListingBodyComponent";
import API_LIST from "../../../../utils/apiList";
import NotFoundComponent from "../../NotFound/NotFoundComponent";
import FilterAndSearchSection from "../../../b2cComponents/FilterAndSearchSection";
import EventSliderFilterSection from "../../Event/EventSliderFilter";
import { useTranslation } from "react-i18next";

const VideoListingContentComponent = (props) => {
  const {
    showAllVideos,
    showMostLiked,
    showMostPopular,
    showMyVideos,
    tabKey,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const observer = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let providerId = "";
  let providerName = "";
  let allPartners = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
    providerName = paramsReq.provider_name;
    allPartners = paramsReq?.allPartners;
  }
  const [selectedPartner, setSelectedPartner] = useState(
    providerId ? "" : "all"
  );
  // const providerId = params.get("provider_id");
  const authBroker = useSelector((state) => state.auth.authBroker);
  const productCategoriesData = useSelector(
    (state) => state.courses.videoProductCategories
  );
  const videoListCatData = useSelector((state) => state.video.videoListCatData);
  const myVideoData = useSelector((state) => state.video.myVideos);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);

  // const [key, setKey] = useState('popular')
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [apiVideoListing, setAPIVideoListing] = useState([]);
  const [videoListing, setVideoListing] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCatIds, setSelectedCatIds] = useState([]);
  const [selectedSubCatIds, setSelectedSubCatIds] = useState([]);
  const [clearSearch, setClearSearch] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [subCatList, setSubCatList] = useState([
    // {id: 10, name: '101 Beginner', catId: 1},
    // {id: 11, name: 'Sub cat', catId: 2},
  ]);
  const [selectedSort, setSelectedSort] = useState(1);
  const [selectedFilter, setSelectedFilter] = useState(1);
  const [sortOption, setSortOption] = useState([
    { value: 1, label: t("Name (A to Z)") },
    { value: 2, label: t("Name (Z to A)") },
    { value: 3, label: t("New To Old") },
    { value: 4, label: t("Old To New") },
  ]);
  const [filterOption, setFilterOption] = useState([
    { value: 1, label: t("all") },
    { value: 4, label: t("Free for you") },
    // { value: 3, label: "Purchased Videos" },
  ]);
  const [searchText, setSearchText] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(CONFIG.PAGINATION_PAGE_SIZE);
  const [hasNoMore, setHasNoMore] = useState(true);
  const [currentKey, setCurrentKey] = useState("");
  const [isResetDone, setIsResetDone] = useState(true);
  const [msgLine, setMsgLine] = useState(t("Nothing here, yet."));

  const [searchedOrNot, setsearchedOrNot] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (tabKey !== currentKey) {
      resetAll();
      console.log("KEY VIDEO", tabKey);
      setCurrentKey(tabKey);
    }
  }, [tabKey]);

  useEffect(() => {
    if (isResetDone) {
      fetchAPIData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    pageNum,
    showMostPopular,
    showAllVideos,
    showMostLiked,
    showMyVideos,
  ]);
  const upcomingVideosResponse = useSelector(
    (state) => state.video.upcomingVideos
  );

  useEffect(() => {
    setSortOption([
      { value: 1, label: t("Name (A to Z)") },
      { value: 2, label: t("Name (Z to A)") },
      { value: 3, label: t("New To Old") },
      { value: 4, label: t("Old To New") },
    ]);
  }, [activeLanguage]);

  useEffect(() => {
    if (!_.isEmpty(productCategoriesData)) {
      console.log(productCategoriesData);
      if (productCategoriesData.status === "success") {
        const payload = productCategoriesData.payload;
        if (!_.isEmpty(payload)) {
          console.log(payload);
          setCategoryList(
            payload.map((c) => {
              return {
                id: c.categoryId,
                name: c.categoryName,
                source: c.source,
              };
            })
          );
        }
      }
    }
  }, [productCategoriesData]);

  useEffect(() => {
    console.log("VIDEO LISTING PAYLOAD", tabKey, videoListCatData, myVideoData);
    if (!_.isEmpty(videoListCatData) || !_.isEmpty(myVideoData)) {
      // const listData = tabKey === 'popular' ? videoListCatData : myVideoData
      let listData = videoListCatData;
      if (showMostLiked) {
      } else if (showMyVideos) {
        listData = myVideoData;
      }
      console.log("LIsting", listData, showMyVideos);
      if (listData.status === "success") {
        const payload = showMyVideos
          ? listData.payload.payload
          : listData.payload.data;
        if (!_.isEmpty(payload)) {
          console.log("VIDEO LISTING PAYLOAD", payload);
          setDataForContent(payload);
        } else {
          setVideoListing([]);
          setMsgLine(
            searchText ? t("Nothing here, as per search.") : t("Nothing here, yet.")
          );
        }
      } else {
        setVideoListing([]);
      }
      setClearSearch(false);
      setIsLoading(false);
      dispatch(getMyVideosClear());
      dispatch(getVideoListCatDataClear());
    }
  }, [videoListCatData, myVideoData]);

  useEffect(() => {
    console.log("VIDEO LISTING PAYLOAD", tabKey, upcomingVideosResponse);
    if (!_.isEmpty(upcomingVideosResponse)) {
      // const listData = tabKey === 'popular' ? videoListCatData : myVideoData
      let listData = upcomingVideosResponse;
      console.log("LIsting", listData);
      if (listData.status === "success") {
        const payload = listData.payload.payload;
        if (!_.isEmpty(payload)) {
          console.log("VIDEO LISTING PAYLOAD", payload);
          setDataForContent(payload);
        } else {
          setVideoListing([]);
          setMsgLine(
            searchText ? t("Nothing here, as per search.") : t("Nothing here, yet.")
          );
        }
      } else {
        setVideoListing([]);
      }
      setClearSearch(false);
      setIsLoading(false);
      dispatch(getMyVideosClear());
      dispatch(getVideoListCatDataClear());
    }
  }, [upcomingVideosResponse]);

  useEffect(() => {
    if (_.isEmpty(apiVideoListing)) {
      console.log("RESET VALUE");
      setIsResetDone(true);
    }
  }, [apiVideoListing]);

  const fetchAPIData = () => {
    switch (tabKey) {
      case "all":
        setFilterOption([
          { value: 1, label: t("all") },
          { value: 4, label: t("Free for you") },
        ]);
        getVideoListFromAPI(selectedIds);
        break;
      case "popular":
        setFilterOption([
          { value: 0, label: t("Overall") },
          { value: 7, label: t("This Week") },
          { value: 30, label: t("This Month") },
        ]);
        getVideoListFromAPI(selectedIds);
        break;
      case "my-videos":
        getMyVideoListFromAPI(selectedIds);
        break;
      case "new-videos":
        setFilterOption([
          { value: 1, label: t("all") },
          { value: 4, label: t("Free for you") },
        ]);
        getNewVideos(selectedIds);
      default:
        break;
    }
  };

  const resetAll = (
    resetSearch = true,
    resetSort = true,
    resetFilter = true
  ) => {
    setIsLoading(true);
    setVideoListing(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setAPIVideoListing([]);
    setIsFetching(false);
    setHasNoMore(true);
    resetSearch && setSearchText("");
    resetSort && setSelectedSort(1);
    resetFilter && setSelectedFilter(1);
    resetSearch && setClearSearch(true);
    setPageNum(1);
    setTotalRecords(0);
  };

  const setDataForContent = async (payload) => {
    const subCat = payload.sub_categories;
    const videoList = payload.videoList;
    setSelectedCatIds(payload.category_id);
    if (!_.isEmpty(subCat)) {
      setSubCatList(
        subCat.map((c) => {
          return {
            id: c.sub_cat_id,
            name: c.sub_cat_name,
            parent: c.parent,
          };
        })
      );
    } else {
      setSubCatList([]);
    }

    await formatVideoDataForProductCard(payload);
  };

  const getVideoCategory = () => {
    dispatch(
      getVideoProductCategories({
        module: "getProductCategoryFromWoo",
        brokerId: authBroker.payload.user.company_id,
        type: "videos",
        provider_id: providerId ? providerId : "",
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      })
    );
  };

  const getVideoListFromAPI = (
    catIds = [],
    subCatIds = [],
    catClick = false
  ) => {
    dispatch(
      getVideoListCatData({
        URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.ALL_VIDEO_LISTING}`,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          category_id: catIds, //!_.isEmpty(catIds) ? catIds : selectedCatIds,
          provider_id: providerId
            ? providerId
            : selectedPartner != "all"
            ? selectedPartner
            : "",
          sort: selectedSort,
          filter: tabKey != "popular" ? selectedFilter : 1,
          page_size: pageSize,
          page: tabKey !== currentKey || catClick ? 1 : pageNum,
          search: searchText,
          popular_tab: tabKey == "popular",
          popular_days: tabKey == "popular" ? selectedFilter : "",
          isAll: allPartners
            ? selectedPartner != "all"
              ? false
              : true
            : false,
          language: activeLanguage ? activeLanguage : "",
        },
        isJSON: true,
        method: "post",
      })
    );
  };

  const getNewVideos = (catIds = [], subCatIds = [], catClick = false) => {
    dispatch(
      getUpcomingVideosReq({
        module: "getUpcomingVideos",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          category_id: catIds,
          provider_id: providerId ? providerId : "",
          sort: selectedSort,
          page_size: pageSize,
          page: tabKey !== currentKey || catClick ? 1 : pageNum,
          search: searchText,
          new_tab: true,
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  const getMyVideoListFromAPI = (
    catIds = [],
    subCatIds = [],
    catClick = false
  ) => {
    dispatch(
      getMyVideos({
        module: "myVideoListData",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          category_id: catIds, //!_.isEmpty(catIds) ? catIds : selectedCatIds,
          provider_id: providerId ? providerId : "",
          sort: selectedSort,
          page_size: pageSize,
          page: tabKey !== currentKey || catClick ? 1 : pageNum,
          search: searchText,
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  /**
   * Navigate to Detail page or Shopping page
   * @param {object} video
   */
  const navigateToView = (video) => {
    console.log("video--", video);

    if (video?.product_type === "bundle") {
      redirectToPageUtil(
        {
          id: video.product_id,
          origin: video.source,
          product_type: "bundle",
        },
        navigate,
        authBroker,
        () => {},
        dispatch,
        "video"
      );
    } else {
      let paramsReq = {
        code: video?.course_code,
        source: video?.source,
        is_paid: video?.priceInfo.isFree,
        provider_name: providerName,
        provider_id: providerId,
      };
      if (!_.isEmpty(video.categoryId)) {
        paramsReq.catId = video?.categoryId[0];
      }
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      // let url = `/video-view-page/${video?.product_id}/po?source=${video?.source}&code=${video?.course_code}&is_paid=${video?.priceInfo.isFree}`;
      // if (!_.isEmpty(video.categoryId)) {
      //   url += `&catId=${video?.categoryId[0]}`;
      // }
      let url = `/video-view-page/${video?.product_id}/?c=${encodedUrl}`;
      navigate(url);
      // if (toDetail) {
      // } else {
      //     let url = `/shopping/${video.product_id}?addToCart=${video?.is_addtocart}&source=videos`;
      //     navigate(url)
      // }
    }
  };

  const assignBrokerCourse = useSelector(
    (state) => state.courses.assignBrokerCourse
  );
  useEffect(() => {
    if (assignBrokerCourse?.status === "success") {
      dispatch(getAssignBrokerCourseClear());
    }
  }, [assignBrokerCourse]);

  const formatVideoDataForProductCard = async (videoList) => {
    console.log("Video LIsting", videoList);
    console.log("Video LIsting API", apiVideoListing);
    setIsResetDone(true);
    let videoArr = [];
    let records = videoList.videoList;
    setTotalRecords(_.toNumber(videoList.total_records));
    for (let video of records) {
      let tags = [];
      let logoURL = "";
      let btnTitle = t("Explore");
      if (video.progress === 100) {
        btnTitle = t("Revisit");
      }
      if (!_.isEmpty(video.provider)) {
        tags.push(
          video?.source === "broker"
            ? video?.provider?.provider_display_name
            : video.provider.display_name
        );
        logoURL = video.provider.provider_img;
      }

      if (video.product_type === "bundle") {
        if (video.video_count > 0)
          tags.push(
            `${video.video_count} ${t("Video")}${video.video_count > 1 ? "s" : ""}`
          );
      } else {
        tags.push(t("Video"));
        tags.push(`${video.views} ${t("View")}${video.views > 1 ? "s" : ""}`);
      }
      if (video.course_duration) {
        const duration = convertTimeFormat(video.course_duration, true);
        tags.push(`${duration}`);
      }

      let priceInfo = getProcureInfo(video.purchased_info);
      video.priceInfo = priceInfo;

      videoArr.push({
        id: video?.product_id,
        is_like: video?.is_like ? video?.is_like : false,
        is_bookmark: video?.is_bookmark ? video?.is_bookmark : false,
        is_wishlist: video?.is_addtowishlist,
        dbId: video?.list_id,
        productType: "video",
        productOrigin: video?.origin,
        title: video.product_name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: video.product_thumbnail,
        tagsArray: tags,
        description: video.long_description,
        duration: convertTimeFormat(video.course_duration, true),
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(video),
        descAction: () => {},
        bannerAction: () => navigateToView(video),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        isLoading: false,
        view: video.views,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        leftBtnIcon: "",
        progress: video?.progress,
        updatedAt: video?.created_dt,
        isBundle: video?.product_type === "bundle",
        bundles: video?.bundles,
      });
    }
    console.log("VIDEO LISTING FORMATTING", videoArr);
    let newVideoArr = videoArr;
    if (pageNum > 1) {
      newVideoArr = [...apiVideoListing, ...videoArr];
      console.log(newVideoArr);
      setVideoListing(newVideoArr);
      setAPIVideoListing(newVideoArr);
      setIsFetching(false);
    } else {
      setVideoListing(videoArr);
      setAPIVideoListing(videoArr);
    }
    console.log("VIDEO LISTING FORMATTING NEW", newVideoArr);
    if (
      _.toNumber(videoList.total_records) === newVideoArr.length ||
      _.toNumber(videoList.total_records) === 0
    ) {
      console.log("HAS NO MORE");
      setIsFetching(false);
      setHasNoMore(true);
      // if (_.toNumber(videoList.total_records) === 0) {
      //   setVideoListing([])
      // }
    } else if (newVideoArr.length < 12) {
      setHasNoMore(true);
    } else {
      console.log("HAS NO MORE IS FALSE");
      setHasNoMore(false);
    }
    if (_.isEmpty(newVideoArr)) {
      console.log("VIDEO LISTING EMPTY ARR");
      setMsgLine(
        searchText ? t("Nothing here, as per search.") : t("Nothing here, yet.")
      );
    }
  };

  const callAPIasPerKey = (catIds = [], subCatIds = []) => {
    if (tabKey === "all") {
      setFilterOption([
        { value: 1, label: t("all") },
        { value: 4, label: t("Free for you") },
      ]);
      getVideoListFromAPI(catIds, subCatIds, true);
    } else if (tabKey === "popular") {
      setFilterOption([
        { value: 0, label: t("Overall") },
        { value: 7, label: t("This Week") },
        { value: 30, label: t("This Month") },
      ]);
      getVideoListFromAPI(catIds, subCatIds, true);
    } else if (tabKey === "my-videos") {
      getMyVideoListFromAPI(catIds, subCatIds, true);
    } else if (tabKey === "new-videos") {
      setFilterOption([
        { value: 1, label: t("all") },
        { value: 4, label: t("Free for you") },
      ]);
      getNewVideos(catIds, subCatIds, true);
    }
  };

  useEffect(() => {
    resetAll(false, false, false);
    setVideoListing(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setAPIVideoListing([]);
    callAPIasPerKey(selectedIds, []);
  }, [
    selectedIds,
    selectedSort,
    selectedFilter,
    selectedPartner,
    activeLanguage,
  ]);

  const paginateCB = useCallback(
    (node) => {
      console.log("isFETCHING", isFetching);
      console.log("isLOADING", isLoading);
      if (isFetching || isLoading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        console.log(entries);
        console.log("hasNoMore", hasNoMore);
        if (entries[0].isIntersecting && !hasNoMore) {
          setIsFetching(true);
          console.log(
            "End of file",
            totalRecords,
            videoListing.length,
            pageNum,
            isLoading,
            isFetching
          );
          setPageNum((pageNum) => pageNum + 1);
          setVideoListing([
            ...videoListing,
            ...CONFIG.INITIAL_PRODUCT_CARD_DATA,
          ]);
        }
      });

      if (node) observer.current.observe(node);
      console.log(node);
    },
    [isLoading, hasNoMore, isFetching, pageNum]
  );

  useEffect(() => {
    // searchInListing(searchText);
  }, [searchedOrNot]);
  const searchInListing = async (searchTxt) => {
    await resetAll(false, false, false);
    fetchAPIData();
  };

  const filterToApply = async (filterType) => {
    await resetAll(false, false, false);
    console.log("VIDEO LISTING API DO", apiVideoListing);
    setSelectedFilter(filterType);
    if (selectedFilter !== filterType) {
      setAPIVideoListing([]);
      fetchAPIData();
    }
  };

  return (
    <div className="contsection video-listing-content">
      <>
        {allPartners ? (
          <EventSliderFilterSection
            selectedPartner={selectedPartner}
            setSelectedPartner={setSelectedPartner}
          />
        ) : (
          ""
        )}
        {
          <FilterAndSearchSection
            sectionType={tabKey !== "my-videos" ? "public" : "myarea"}
            entityType={"video"}
            searchText={searchText}
            setSearchText={setSearchText}
            setsearchedOrNot={setsearchedOrNot}
            searchedOrNot={searchedOrNot}
            setFilterBy={setSelectedFilter}
            filterBy={selectedFilter}
            filterOption={filterOption}
            setSortBy={setSelectedSort}
            sortBy={selectedSort}
            sortOption={sortOption}
            setSelectedIds={setSelectedIds}
            isFilterShow={
              tabKey !== "my-videos" &&
              tabKey !== "all" &&
              tabKey !== "new-videos"
            }
            isLoading={isLoading}
            tabKey={tabKey}
            selectedPartner={selectedPartner}
          />
        }

        <div className="mgt-3">
          {isLoading || !videoListing.length ? (
            ""
          ) : (
            <span className="count-text-head">
              {totalRecords > 0 ? (
                <>
                  {t("We found")} {totalRecords} video
                  {totalRecords > 1 ? "s" : ""} {t("for you")}
                </>
              ) : (
                ""
              )}
            </span>
          )}
          <div className="row coursecard-row videosection-cont">
            {videoListing.length > 0 ? (
              videoListing.map((v, i) => {
                return (
                  <ProductCardComponent
                    {...v}
                    key={`video-${i + 1}`}
                    lastKey={videoListing.length === i + 1}
                    refInfo={paginateCB}
                  />
                );
              })
            ) : (
              <NotFoundComponent
                width={400}
                height={419}
                showBtn={false}
                showMsg={true}
                msgLine={msgLine}
              />
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default VideoListingContentComponent;
